export let FeedbackVariant = /*#__PURE__*/function (FeedbackVariant) {
  FeedbackVariant["LIKE"] = "like";
  FeedbackVariant["CHECK"] = "check";
  return FeedbackVariant;
}({});
export let CheckedValue = /*#__PURE__*/function (CheckedValue) {
  CheckedValue["POSITIVE"] = "positive";
  CheckedValue["NEGATIVE"] = "negative";
  CheckedValue["UNSELECTED"] = "unselected";
  return CheckedValue;
}({});